const map = {
	"./accordion/index.scss": "../css/components/accordion/index.scss",
	"./articles/index.scss": "../css/components/articles/index.scss",
	"./banner-top/index.scss": "../css/components/banner-top/index.scss",
	"./base-card-slider/index.scss": "../css/components/base-card-slider/index.scss",
	"./base-filters/index.scss": "../css/components/base-filters/index.scss",
	"./blocks/chart-block.scss": "../css/components/blocks/chart-block.scss",
	"./cards/card-about-company.scss": "../css/components/cards/card-about-company.scss",
	"./cards/card-conduct-code.scss": "../css/components/cards/card-conduct-code.scss",
	"./cards/card-course.scss": "../css/components/cards/card-course.scss",
	"./cards/card-employee.scss": "../css/components/cards/card-employee.scss",
	"./cards/card-feature.scss": "../css/components/cards/card-feature.scss",
	"./cards/card-financial-reporting.scss": "../css/components/cards/card-financial-reporting.scss",
	"./cards/card-investor-calendar.scss": "../css/components/cards/card-investor-calendar.scss",
	"./cards/card-news.scss": "../css/components/cards/card-news.scss",
	"./cards/card-newspaper.scss": "../css/components/cards/card-newspaper.scss",
	"./cards/card-photo.scss": "../css/components/cards/card-photo.scss",
	"./cards/card-press-release.scss": "../css/components/cards/card-press-release.scss",
	"./cards/card-project.scss": "../css/components/cards/card-project.scss",
	"./cards/card-short-info-disclosure.scss": "../css/components/cards/card-short-info-disclosure.scss",
	"./cards/card-statistics.scss": "../css/components/cards/card-statistics.scss",
	"./cards/card-vacancy.scss": "../css/components/cards/card-vacancy.scss",
	"./cards/card-video.scss": "../css/components/cards/card-video.scss",
	"./cards/tile-with-icon.scss": "../css/components/cards/tile-with-icon.scss",
	"./contact-information/index.scss": "../css/components/contact-information/index.scss",
	"./contacts-block-with-desc/index.scss": "../css/components/contacts-block-with-desc/index.scss",
	"./content.scss": "../css/components/content.scss",
	"./control/button.scss": "../css/components/control/button.scss",
	"./control/link-more.scss": "../css/components/control/link-more.scss",
	"./custom-checkbox/index.scss": "../css/components/custom-checkbox/index.scss",
	"./dropdown-section/index.scss": "../css/components/dropdown-section/index.scss",
	"./elements/contact-block.scss": "../css/components/elements/contact-block.scss",
	"./elements/course-table.scss": "../css/components/elements/course-table.scss",
	"./elements/donut-chart.scss": "../css/components/elements/donut-chart.scss",
	"./elements/file-item.scss": "../css/components/elements/file-item.scss",
	"./filters/index.scss": "../css/components/filters/index.scss",
	"./footer/index.scss": "../css/components/footer/index.scss",
	"./gallery/index.scss": "../css/components/gallery/index.scss",
	"./header/header.scss": "../css/components/header/header.scss",
	"./headline-group/index.scss": "../css/components/headline-group/index.scss",
	"./language-select/index.scss": "../css/components/language-select/index.scss",
	"./lists/legend-list.scss": "../css/components/lists/legend-list.scss",
	"./lists/list-menu-bottom.scss": "../css/components/lists/list-menu-bottom.scss",
	"./lists/list-press-center.scss": "../css/components/lists/list-press-center.scss",
	"./lists/list-statistics.scss": "../css/components/lists/list-statistics.scss",
	"./lists/list-with-divider.scss": "../css/components/lists/list-with-divider.scss",
	"./loader/index.scss": "../css/components/loader/index.scss",
	"./main-banner/index.scss": "../css/components/main-banner/index.scss",
	"./main-menu/index.scss": "../css/components/main-menu/index.scss",
	"./mobile-menu/index.scss": "../css/components/mobile-menu/index.scss",
	"./page-head/page-head.scss": "../css/components/page-head/page-head.scss",
	"./pagination/index.scss": "../css/components/pagination/index.scss",
	"./previous_page/previous_page.scss": "../css/components/previous_page/previous_page.scss",
	"./progress/index.scss": "../css/components/progress/index.scss",
	"./progress/progress-bar-production.scss": "../css/components/progress/progress-bar-production.scss",
	"./search/search-dropdown.scss": "../css/components/search/search-dropdown.scss",
	"./search/search-form.scss": "../css/components/search/search-form.scss",
	"./sections/index.scss": "../css/components/sections/index.scss",
	"./select/index.scss": "../css/components/select/index.scss",
	"./select2/index.scss": "../css/components/select2/index.scss",
	"./share/index.scss": "../css/components/share/index.scss",
	"./simplebar/index.scss": "../css/components/simplebar/index.scss",
	"./sliders/slider-company-newspaper.scss": "../css/components/sliders/slider-company-newspaper.scss",
	"./sliders/slider-features.scss": "../css/components/sliders/slider-features.scss",
	"./sliders/slider-financial-reporting.scss": "../css/components/sliders/slider-financial-reporting.scss",
	"./sliders/slider-gallery.scss": "../css/components/sliders/slider-gallery.scss",
	"./sliders/slider-one-full-width-el.scss": "../css/components/sliders/slider-one-full-width-el.scss",
	"./sliders/slider-projects.scss": "../css/components/sliders/slider-projects.scss",
	"./sliders/slider-videos.scss": "../css/components/sliders/slider-videos.scss",
	"./swiper/index.scss": "../css/components/swiper/index.scss",
	"./table/index.scss": "../css/components/table/index.scss",
	"./tabs/index.scss": "../css/components/tabs/index.scss",
	"./tiles-with-icons/index.scss": "../css/components/tiles-with-icons/index.scss",
	"./vacancy/filters.scss": "../css/components/vacancy/filters.scss",
	"./vacancy/sorting.scss": "../css/components/vacancy/sorting.scss",
	"./video-preview.scss": "../css/components/video-preview.scss"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../css/components sync recursive \\.scss$";